module.exports = __webpack_public_path__ + "img/PayPal.5dc38faa.png";